/* ================================================================ */
// HEADER COMPONENT | Header.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/styles/makeStyles';
/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(theme => ({
    header: {
        height: '12em',
        display: 'flex',
        flexDirection: 'column'
    },
    container: {
        padding: '1rem 2rem',
        height: 'calc(100% - 2rem)',
        width: 'calc(100% - 4rem)'
    },
    logo: {
        objectFit: 'contain',
        width: '100%',
        height: '100%'
    },
    title: {
        '& span': {
            color: theme.palette.primary.main
        }
    },
    subtitle: {}
}));
/* ========================================== */
/**
 * Header
 * ------
 * Header output with provided branding
 *
 * @param {object} props component props
 * @param {string} props.logo logo uri
 * @param {string} props.title title
 * @param {string} props.subtitle subtitle
 * @param {object} props.styles style overrides
 */
/* ========================================== */
const Header = ({logo, title, subtitle, styles}) => {
    const classes = useStyles();
    //const Logo = logo ? <img alt="Logo" src={logo} className={classes.logo} /> : <Typography variant="h1" color="textPrimary" className={classes.title}>{title}</Typography>
    return (
        <header className={classes.header} style={styles}>
            <div className={classes.container}>
                <img alt="Logo" src={logo} className={classes.logo} />
                {title &&
                    <Typography variant="h1" color="textPrimary" className={classes.title}>{title}</Typography>
                }
                {subtitle &&
                    <Typography variant="subtitle1" color="textPrimary" className={classes.subtitle}>{subtitle}</Typography>
                }
            </div>
        </header>
    );
};
Header.propTypes = {
    logo: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    styles: PropTypes.object
};
Header.defaultProps = {
    logo: '/assets/logo.png',
    styles: {}
};
/* ========================================== */
// Export
/* ========================================== */
export default Header;